import React from 'react';
import DevicesOutlinedIcon from '@material-ui/icons/DevicesOutlined';
import EmojiObjectsOutlinedIcon from '@material-ui/icons/EmojiObjectsOutlined';
import PeopleAltOutlinedIcon from '@material-ui/icons/PeopleAltOutlined';
import TrendingUpOutlinedIcon from '@material-ui/icons/TrendingUpOutlined';

const ConteudoQuemSomosAD = () => (
  <div className="page-contato" style={{fontSize: 16, backgroundColor: '#ffffff'}}>
    <section className="gv-section">
      <div className="section-content">
        <h2 className="gv-title">A Siqueira Tur</h2>
        <p className="txt-item">Desde 2005, a Siqueira Tur tem cumprido sua missão com dedicação: transportar pessoas com segurança, conforto e responsabilidade. Nossa jornada começou na BR-319, em uma linha de transporte escolar entre Humaitá e Manaus, usando o primeiro ônibus da empresa — um Thamco Mbb 1318 (modelo 1990/91). Nos dias de menor demanda escolar, passávamos pela região de Realidade (km 100 em direção a Manaus).</p>
        <p className="txt-item">Com o tempo, ampliamos nossa estrutura e alcance, inaugurando filiais em Manaus e Manicoré, além da matriz em Humaitá (Rua Nordestina, 1950, São Cristóvão). Hoje, atuamos como transportadora interestadual de passageiros com itinerários regulares e também oferecemos transporte escolar, fretamento, organização de viagens, excursões e serviços de logística e turismo.</p>
        <p className="txt-item">Registrada como Siqueira Tur Transporte e Turismo LTDA, estamos ativos e em permanente crescimento. Nosso compromisso é com a segurança e satisfação dos nossos clientes — sempre com foco no cuidado e eficiência que você merece. Conte com a gente para suas viagens, por todo o Amazonas e o Brasil.</p>        

        <section className="gv-cards" style={{ marginTop: 50 }}>
          <div className="gv-cards-wrapper">
            <div className="gv-card gv-card-qs">
              <div className="nome-card">
                <span className="box-item-card-title">
                  <DevicesOutlinedIcon className="box-item-icon"></DevicesOutlinedIcon>
                  <p>Tecnologia</p>
                  <div className="divider"/>
                </span>
                <span className="box-item-card-info">
                  <p>Descomplicamos o jeito antigo e complicado de comprar uma passagem!</p>
                </span>
              </div>
            </div>
            <div className="gv-card gv-card-qs">
              <div className="nome-card">
                <span className="box-item-card-title">
                  <EmojiObjectsOutlinedIcon className="box-item-icon"></EmojiObjectsOutlinedIcon>
                  <p>Inovação</p>
                  <div className="divider"/>
                </span>
                <span className="box-item-card-info">
                  <p>Inovamos em um mercado promissor. Tecnologia simples, aplicada e segura para você, sua família e amigos.</p>
                </span>
              </div>
            </div>
            <div className="gv-card gv-card-qs">
              <div className="nome-card">
                <span className="box-item-card-title">
                  <PeopleAltOutlinedIcon className="box-item-icon"></PeopleAltOutlinedIcon>
                  <p>Relacionamento</p>
                  <div className="divider"/>
                </span>
                <span className="box-item-card-info">
                  <p>Pensamos em você muito mais que um simples cliente, temos você como parte de nossa empresa. Sem você não teríamos motivos para estar aqui!</p>
                </span>
              </div>
            </div>
            <div className="gv-card gv-card-qs">
              <div className="nome-card">
                <span className="box-item-card-title">
                  <TrendingUpOutlinedIcon className="box-item-icon"></TrendingUpOutlinedIcon>
                  <p>Agilidade</p>
                  <div className="divider"/>
                </span>
                <span className="box-item-card-info">
                  <p>Rápido e descomplicado. Clicou, comprou, viajou!</p>
                </span>
              </div>
            </div>
          </div>
        </section>
      </div>
    </section>
  </div>
)

export default ConteudoQuemSomosAD

